import { createStore } from 'reusable';
import { useTheme } from '../hooks/useTheme';

export default createStore(() => useTheme());
